const PAYMENTS_BASE_URL =
  process.env.NODE_ENV === "production" ? "" : process.env.BACKEND_API_HOST;

export const CHECKOUT_SESSION_URL = `${PAYMENTS_BASE_URL}/payments/create-checkout-session`;
